<template>
  <div class="home">
    <v-app id="block" v-cloak>
      <v-content>
        <v-container>
          <v-layout justify-center>
            <v-flex xs12 sm8 md4>
              <v-card class="elevation-6">
                <v-toolbar dark color="teal">
                  <v-toolbar-title style="color: #fff">SIGN IN</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                  <v-form @submit.prevent="">
                    <v-text-field v-model="email" prepend-icon="email" name="email" label="Email" id="email" type="email"></v-text-field>
                    <v-text-field v-model="password" @keyup.enter="signIn" prepend-icon="lock" name="password" label="Password" id="password" type="password"></v-text-field>
                    <p v-if="error != ''">{{ error }}</p>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn type="submit" @click="signIn" dark color="teal">submit</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import Firebase from "firebase";

export default {
  data: function() {
    return {
      email: "",
      password: ""
    }
  },
  methods: {
    signIn: function() {
      Firebase.auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          // eslint-disable-next-line
          user => {
            this.$router.replace('data');
          },
          error => {
            alert(error.message);
          }
        );
    }
  }
};
</script>

<style scoped>
nav.v-toolbar.theme--dark.teal {
  box-shadow: none;
}
div#block {
    background-image: url(https://pawtocol.com/images/bgdata.png) !important;
    background-blend-mode: overlay;
    background-color: #adadad;
    background-size: cover;
}
html, body {overflow: hidden}
</style>